import ApiUtils from '@/utils/api/ApiUtils'

export default {
  async doAdd ({ commit, state }, payload) {
    await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.doAdd.api, input: payload }]
    })
  },
  async getEdit ({ commit, state }, payload) {
    const res = await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.getEdit.api, input: payload }]
    })
    commit('SET_ROW', res[0].output)
  },
  async doEdit ({ commit, state }, payload) {
    await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.doEdit.api, input: payload }]
    })
  },
  async doRead ({ commit, state }, payload) {
    const res = await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.doRead.api, input: payload }]
    })
    commit('SET_ROW', res[0].output)
  },
  async doBrowse ({ commit, state }, payload) {
    const val = {
      searchInfo: state.searchInfo,
      orderBy: state.orderBy,
      pagination: state.pagination
    }
    const res = await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.doBrowse.api, input: val }]
    })
    commit('SET_ROWS', res[0].output.data)
    commit('SET_PAGINATION', res[0].output.pagination)
  },
  async doDelete ({ commit, state }, payload) {
    await ApiUtils.postData({
      data: [{ api: state.PageConst.ACTION.doDelete.api, input: payload }]
    })
  }
}
